import ConfirmationModal from 'components/Modals/ConfirmationModal';

// Confirmation modal for deleting a device group.
export default function DeleteGroupModal({ toDelete, resolveDelete }) {
  return (
    <ConfirmationModal
      show={!!toDelete}
      handleShow={() => resolveDelete(false)}
      centered
      size="md"
      bodyTxt={
        <div>
          <p className="text-center">
            Are you sure you want to delete <br />
            <span className="fw-bolder">{toDelete?.name || '???'}</span>
            <br />
            from the workplace?
          </p>
        </div>
      }
      cancelBtnTxt={'Cancel'}
      confirmBtnTxt={'Yes'}
      confirmHandler={() => resolveDelete(true)}
      cancelHandler={() => resolveDelete(false)}
    />
  );
}
